var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-flex language align-items-center"},[_c('a',{staticClass:"nav-link px-0 py-3 my-1",attrs:{"href":"#"},on:{"click":function($event){return _vm.setLocale('ka')}}},[_vm._v("ქარ")]),_vm._v(" "),_c('a',{staticClass:"nav-link px-0 py-3 my-1 pr-2",attrs:{"href":"#"},on:{"click":function($event){return _vm.setLocale('en')}}},[_vm._v("ENG")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad89892","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/language-switcher.vue
// module id = 492
// module chunks = 40